import { Component, Input } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
    selector: "ece-btn-icon",
    templateUrl: "./ece.button.component.html",
    standalone: false
})
export class IconButtonComponent extends EceButtonComponent {
  @Input() icon: string;
}
